export function installFragment(target) {
  return target
}
